/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Buy_As_GiftInputs */

const en_buy_as_gift = /** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy as Gift for a Friend`)
};

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const es_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const fr_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const de_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const ja_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const zh_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const ar_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const id_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const it_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const ru_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const pt_buy_as_gift = en_buy_as_gift;

/** @type {(inputs: Buy_As_GiftInputs) => LocalizedString} */
const ko_buy_as_gift = en_buy_as_gift;

/**
* | output |
* | --- |
* | "Buy as Gift for a Friend" |
*
* @param {Buy_As_GiftInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const buy_as_gift = /** @type {((inputs?: Buy_As_GiftInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buy_As_GiftInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_buy_as_gift(inputs)
	if (locale === "es") return es_buy_as_gift(inputs)
	if (locale === "fr") return fr_buy_as_gift(inputs)
	if (locale === "de") return de_buy_as_gift(inputs)
	if (locale === "ja") return ja_buy_as_gift(inputs)
	if (locale === "zh") return zh_buy_as_gift(inputs)
	if (locale === "ar") return ar_buy_as_gift(inputs)
	if (locale === "id") return id_buy_as_gift(inputs)
	if (locale === "it") return it_buy_as_gift(inputs)
	if (locale === "ru") return ru_buy_as_gift(inputs)
	if (locale === "pt") return pt_buy_as_gift(inputs)
	return ko_buy_as_gift(inputs)
});